import { Box, Flex, FlexProps } from "rebass"
import styled from "styled-components"
import { display, DisplayProps } from "styled-system"

export default styled(Flex)<DisplayProps & FlexProps>`
  ${display}
`
